export default __webpack_public_path__ + "static/media/kayak-double.6a97265b.png";